module.exports = __webpack_public_path__ + "img/4.e211f817.png";